import logoimg from '@/assets/img/imgpsh_fullsize_anim_front.png';
import Card from '@/components/Card/Card';
import CardBody from '@/components/Card/CardBody';
import CardHeader from '@/components/Card/CardHeader';
import Button from '@/components/CustomButtons/Button';
import CustomInput from '@/components/CustomInput/CustomInput';
import GridContainer from '@/components/Grid/GridContainer';
// core components
import GridItem from '@/components/Grid/GridItem';
import FloatingLanguagePicker from '@/components/LanguagePicker/FloatingLanguagePicker';
import PoweredByTailfin from '@/components/PoweredByTailfin';
import axios from 'axios';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API_BASE_URL } from '../../config';

export default function Resetpassword() {
  const { t } = useTranslation();
  const [newpassword, setNewpassword] = useState('');
  const [confirmpassword, setConfirmpassword] = useState('');
  const [otp, setOtp] = useState('');
  const [message, setMessage] = useState('');

  const handleNewpassword = (event) => {
    setNewpassword(event.target.value);
  };

  const handleOTP = (event) => {
    setOtp(event.target.value);
  };

  const handleConfirmpassword = (event) => {
    setConfirmpassword(event.target.value);
  };

  const resetpassword = (e) => {
    e.preventDefault();

    var newPassword = newpassword;
    var minNumberofChars = 8;
    var maxNumberofChars = 25;
    var regularExpression = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

    if (newpassword == '') {
      alert(t('validation.passwordRequired'));
    } else if (
      newPassword.length < minNumberofChars ||
      newPassword.length > maxNumberofChars
    ) {
      alert(t('validation.passwordLength'));
    } else if (!regularExpression.test(newPassword)) {
      alert(t('validation.passwordComplexity'));
    } else if (confirmpassword == '') {
      alert(t('validation.confirmPasswordRequired'));
    } else if (confirmpassword != newpassword) {
      alert(t('validation.passwordMismatch'));
    } else {
      const formData = new FormData();

      formData.append('password', newpassword);
      formData.append('email', localStorage.getItem('forgotEmail'));
      formData.append('otp', otp);

      axios
        .post(API_BASE_URL + '/resetpassword', formData)
        .then((response) => {
          return response;
        })
        .then((res) => {
          console.log(res.data.redirect);
          window.location.href = `/user/${
            res.data.redirect === 'admin' ? 'login' : 'Facilitylogin'
          }`;
        })
        .catch((err) => {
          console.log('dfdf', err);
          setMessage(err.response.data.msg);
        });
    }
  };

  return (
    <>
      <FloatingLanguagePicker />
      <form onSubmit={resetpassword}>
        <GridContainer alignItems='center' justify='center'>
          <GridItem xs={8} sm={8} md={8}>
            <Card>
              <CardHeader color='primary'>
                <GridContainer alignItems='center' justify='space-between'>
                  <GridItem xs={8} sm={8} md={6}>
                    <h4>{t('auth.resetPassword.title')}</h4>
                  </GridItem>
                  <GridItem xs={8} sm={8} md={6}>
                    <img src={logoimg} width='130' />
                  </GridItem>
                </GridContainer>
              </CardHeader>
              <CardBody>
                {message && (
                  <GridContainer>
                    <GridItem xs={8} sm={8} md={6}>
                      <p style={{ color: 'red' }}>{message}</p>
                    </GridItem>
                  </GridContainer>
                )}
                <GridContainer>
                  <GridItem xs={8} sm={8} md={6}>
                    <CustomInput
                      labelText={t('auth.resetPassword.newPasswordLabel')}
                      id='heading'
                      name='heading'
                      type='password'
                      onChange={handleNewpassword}
                      value={newpassword}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={8} sm={8} md={6}>
                    <CustomInput
                      labelText={t('auth.resetPassword.confirmPasswordLabel')}
                      id='subheading'
                      type='password'
                      name='subheading'
                      onChange={handleConfirmpassword}
                      value={confirmpassword}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>

                  <GridItem xs={8} sm={8} md={6}>
                    <CustomInput
                      labelText={t('auth.resetPassword.otpLabel')}
                      id='OTP'
                      name='OTP'
                      type='OTP'
                      onChange={handleOTP}
                      value={otp}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>

                <GridContainer alignItems='center'>
                  <GridItem xs={8} sm={8} md={6}>
                    <Button color='primary' type='submit'>
                      {t('auth.resetPassword.submitButton')}
                    </Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </form>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}>
        <PoweredByTailfin size='medium' />
      </div>
    </>
  );
}
